import { useState } from "react";
import ChatBubble from "./ChatButtle";
import FeedbackModal from "./FeedbackModal";
import ChatBox from "./ChatBox";
import assistentAPI from "apis/AssistentAPI";
import dayjs from "dayjs";
import "./style.css";

export interface historyItem {
  responseId?: string;
  role: "user" | "assistant";
  content: string;
  time: string;
  feedback?: boolean;
};

export interface feedbackModalProps {
  isOpen: boolean;
  idconsulta?: string;
  pergunta?: string;
  resposta?: string;
  avaliacao?: boolean;
};

function AiAssistent(){
  
  const [ loading, setLoading ] = useState(false);
  const [ isChatOpen, setIsChatOpen ] = useState(false);
  const [ history, setHistory ] = useState<historyItem[]>([]);
  const [ feedbackModal, setFeedbackModal ] = useState<feedbackModalProps>({ isOpen: false });

  const handleSubmitQuestion = (question: string) => {
    setLoading(true);
    
    setHistory(
      [...history,
        {
          role: "user",
          content: question,
          time: dayjs().format('HH:mm')
        }
      ]
    );

    assistentAPI.question(question, history)
      .then((response) => {

        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(`<body>${response.resposta}</body>`,"text/xml");
        let fieldValue = xmlDoc.getElementsByTagName('resposta')[0].childNodes[0].nodeValue!.slice(1);

        setLoading(false);
        
        setHistory((prevState: any) => 
          [...prevState,
            {
              responseId: response.id,
              role: "assistant",
              content: fieldValue,
              time: dayjs().format('HH:mm')
            }
          ]
        );
      })
      .catch(() => {
        setLoading(false);
        alert("O assistente de IA está indisponível no momento. Tente novamente mais tarde.");
      });
    };

    const handleSubmitFeedback = (comentario: string) => {
      assistentAPI.feedBack({
        idconsulta: feedbackModal.idconsulta!,
        pergunta: feedbackModal.pergunta!,
        resposta: feedbackModal.resposta!,
        avaliacao: feedbackModal.avaliacao!,
        comentario: comentario
      })
      .then(() => {
        let reviewedResponse = history.find(item => item.responseId === feedbackModal.idconsulta);
        reviewedResponse!.feedback = feedbackModal.avaliacao;

        setHistory(history);
        setFeedbackModal({ isOpen: false });
      })
      .catch(() => {
        alert('Não foi possível enviar seu feedback. Tente novamente mais tarde.');
      });
    };

    return(
      <>
        <ChatBubble
          onClick={() => setIsChatOpen(true)}
        />
        <FeedbackModal
          isOpen={feedbackModal.isOpen}
          onClose={() => setFeedbackModal({ isOpen: false })}
          onSubmit={handleSubmitFeedback}
        />
        <ChatBox
          history={history}
          isLoading={loading}
          isChatOpen={isChatOpen}
          onSubmitQuestion={handleSubmitQuestion}
          onOpenFeedbackModal={setFeedbackModal}
          onClose={() => setIsChatOpen(false)}
        />
      </>
    )
};
export default AiAssistent;